import {
  bool, func, oneOf,
} from 'prop-types';
import styled, { css } from 'styled-components';
import { Input } from '@atoms';
import { marginMixin } from '@mixins';

const {
  margin,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
} = marginMixin;

const TextArea = styled(Input)`
    ${({
    theme: {
      spacing, typography,
    },
  }) => css`
      ${margin}
      ${marginTop}
      ${marginRight}
      ${marginBottom}
      ${marginLeft}
  
      height: 90px;
      font-size: ${typography.size.xl};
      font-weight: ${typography.weight.bold};
      padding: ${spacing.md};
      resize: none;

      -ms-overflow-style: none;
      scrollbar-width: none;
      ::-webkit-scrollbar {
        display: none;
      }
    `}
  `;

TextArea.defaultProps = {
  isError: false,
  type: 'text',
  onChange: () => null,
};

TextArea.propTypes = {
  isError: bool,
  type: oneOf([
    'password',
    'text',
  ]),
  onChange: func,
};

export default TextArea;
